import Delta from 'quill-delta';

export function formatParsedQuillTableData(parsedQuill) {
    const paragraphs = parsedQuill.paragraphs;

    let table = null;
    const formattedParagraphs = [];

    paragraphs.forEach((paragraph) => {
        if (paragraph.attributes?.row) {
            if (!table) {
                table = {
                    attributes: {
                        table: true,
                    },
                    rows: [],
                };
            }

            let row = table.rows?.find((row) => row.attributes?.row === paragraph.attributes?.row);

            if (!row) {
                row = {
                    attributes: {
                        row: paragraph.attributes.row,
                    },
                    cells: [],
                };

                table.rows?.push(row);
            }

            row.cells?.push(paragraph);
        } else {
            if (table) {
                formattedParagraphs.push(table);

                table = null;
            }

            formattedParagraphs.push(paragraph);
        }
    });

    if (table) {
        formattedParagraphs.push(table);
    }

    return formattedParagraphs;
}

export function base64ToArrayBuffer(base64) {
    const binaryString = atob(base64); // Decode base64 to binary string
    const length = binaryString.length;
    const bytes = new Uint8Array(length);

    for (let i = 0; i < length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }

    return bytes.buffer;
}

export function getFileExtension(base64String) {
    const match = base64String.match(/^data:image\/([a-zA-Z]+);base64,/);
    return match ? match[1] : null;
}

export function getImageDimensions(base64) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight });
        img.onerror = reject;
        img.src = base64;
    });
}

export function pxToHalfPt(px) {
    return Math.round(px * 1.5);
}

export function ptToHalfPt(pt) {
    return Math.round(pt * 2);
}

export function ptToPx(pt) {
    return Math.round(pt * 1.33);
}

export function getDiffDelta(oldDelta, newDelta) {
    const diff = oldDelta.diff(newDelta);
    const formattedOps = [];

    diff.ops.forEach((op) => {
        if (op.delete) {
            formattedOps.push({
                retain: op.delete,
                attributes: {
                    ...op.attributes,
                    strike: true,
                    color: '#395BA9',
                },
            });
        } else if (op.insert) {
            formattedOps.push({
                insert: op.insert,
                attributes: {
                    ...op.attributes,
                    color: '#55BE8B',
                    background: '#E8FFEE',
                },
            });
        } else {
            formattedOps.push(op);
        }
    });

    return {
        formattedDelta: new Delta(formattedOps),
        editsCount: diff.ops.filter((op) => op.retain).length,
    };
}

export function composeDeltas(oldDelta, formattedDelta) {
    return oldDelta.compose(formattedDelta);
}

export function addSpacingToHtml(html) {
    return (
        html
            // Collapse multiple consecutive <p><br></p> blocks into at most 2
            .replace(/(<p><br><\/p>\s*){3,}/g, '<p><br></p><p><br></p>')

            // ----------------------
            // HEADINGS (H1-H2)
            // ----------------------

            // Add 2 line breaks before h1–h2 (if not already there)
            .replace(/(<\/(p|ul|ol|table)>)(\s*)<h([1-2])>/g, '</$2><p><br></p><p><br></p><h$4>')

            // Ensure exactly 1 line break after h1–h2 before next <p>, <ul>, <ol>, or <table>
            .replace(/<\/h([1-2])>(\s*)(?=<(p|ul|ol|table|img|h[1-6]))/g, '</h$1><p><br></p>')

            // Prevent accidental stacked <br> blocks after headers
            .replace(/(<\/h[1-2]>)<p><br><\/p><p><br><\/p>/g, '$1<p><br></p>')

            // ----------------------
            // PARAGRAPH ↔ PARAGRAPH
            // ----------------------

            .replace(/<\/p><p>/g, '</p><p><br></p><p>')

            // ----------------------
            // PARAGRAPH ↔ LIST
            // ----------------------

            .replace(/<\/p><(ul|ol)>/g, '</p><p><br></p><$1>')
            .replace(/<\/(ul|ol)><p>/g, '</$1><p><br></p><p>')
            .replace(/<\/(ul|ol)><(ul|ol)>/g, '</$1><p><br></p><$2>')

            // ----------------------
            // HEADINGS BETWEEN LISTS
            // (ul><h2></h2><ol>)
            // ----------------------

            .replace(/<\/(ul|ol)>\s*<h([1-2])>/g, '</$1><p><br></p><p><br></p><h$2>')
            .replace(/<\/h([1-2])>\s*<(ul|ol)>/g, '</h$1><p><br></p><$2>')

            // ----------------------
            // TABLES
            // ----------------------

            // Paragraph before/after table
            .replace(/<\/p><table/g, '</p><p><br></p><table')
            .replace(/<\/table><p>/g, '</table><p><br></p><p>')

            // Table after header
            .replace(/<\/h([1-2])>\s*<table/g, '</h$1><p><br></p><table')

            // Consecutive tables
            .replace(/<\/table><table/g, '</table><p><br></p><table')

            // ----------------------
            // IMAGES
            // ----------------------

            .replace(/<\/p><img /g, '</p><p><br></p><img ')
            .replace(/<\/img><p>/g, '</img><p><br></p><p>')

            // Final pass: collapse accidental double spacing again
            .replace(/(<p><br><\/p>\s*){3,}/g, '<p><br></p><p><br></p>')
    );
}
